import React from 'react';
import { useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from './ArcButton';

const COLOR_BUTTON_FILL = '#505559';
const COLOR_ARC = '#3DCD58';

interface ContactSupportButtonProps {
  path: string;
  w?: string;
  isDisabled?: boolean;
}

export const ContactSupportButton = ({ path, w = '100%', isDisabled }: ContactSupportButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const buttonFill = useColorModeValue(COLOR_BUTTON_FILL, COLOR_BUTTON_FILL);

  return (
    <ArcButton
      arcColor={COLOR_ARC}
      background={buttonFill}
      _hover={{ background: buttonFill }}
      borderColor={buttonFill}
      sx={{ '> div': { background: `${buttonFill} !important` } }}
      color="white"
      w={w}
      mt={6}
      onClick={() => navigate(path)}
      isDisabled={isDisabled}
      data-testid={'contact-support-button'}
      textOverflow="auto"
    >
      {t('Common.contact support')}
    </ArcButton>
  );
};
